import { render } from "./NotFound.vue?vue&type=template&id=47eb121d&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=47eb121d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47eb121d"]])

export default __exports__